import types from './types';

// const clearAuth = () => ({
//   type: types.CLEAR_SEARCH
// })


const updateCurrentChat = id => ({
	type: types.UPDATE_CURRENT_CHAT,
	payload: id
});

export default {
	// clearSearch,
	updateCurrentChat
};

